import { useEffect, useRef, useState } from 'react';

import { pageProgressMap } from '@/utils/contants/caseSimulation';
import { curPageProgressIsCompleted, getToPathByStage } from './utils';

const useEventResult = (props) => {
    let timerRef = useRef(null);
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    let { navigate, params, side = 'web' } = props;
    let { agentId, caseId, sceneId } = params;
    const { simulation } = props.store;
    let { eventResult = {}, setHeaderIcon, getApiProgress, pageProgress, getContent, getPath } = simulation;

    const goReport = () => {
        let path = getPath();
        navigate(`${path}/review-report`, { replace: true });
    };

    useEffect(() => {
        setHeaderIcon({
            role: true,
            back: true,
            reStart: true
        });
    }, []);
    //清除定时器
    const clearTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };
    // const startTimer = () => {
    //     if (timerRef.current) {
    //         return;
    //     }
    //     timerRef.current = setInterval(() => {
    //         getApiProgress(caseId);
    //     }, 3000);
    // };
    const getProgress = async () => {
        let progress = await getApiProgress(caseId);
        let status = curPageProgressIsCompleted(progress, pageProgressMap['event_result_generating']);
        if (status === 'completed') {
            await getContent();
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            clearTimer();
        }
    };
    const startTimer = () => {
        if (timerRef.current) {
            return;
        }
        timerRef.current = setInterval(() => {
            getProgress();
        }, 3000);
    };

    //第一次进入页面的时候获取进度更改页面loading状态
    const getProgressInFirst = async () => {
        setPageLoading(true);
        let progress = await getApiProgress(caseId);
        let status = curPageProgressIsCompleted(progress, pageProgressMap['event_result_generating']);
        if (status === 'completed') {
            await getContent();
            setPageLoading(false);
        } else if (status === 'ing') {
            setLoading(true);
            setPageLoading(false);
            startTimer();
        } else {
            console.log('未完成');
            let path = getToPathByStage(pageProgress);
            console.log(path, '跳转了path');

            navigate(`/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/${path}`, { replace: true });
        }
    };
    useEffect(() => {
        getProgressInFirst();
        return () => {
            clearTimer();
        };
    }, []);
    const reGenerateReport = () => {
        getProgressInFirst();
    };
    return {
        timerRef,
        pageLoading,
        setPageLoading,
        loading,
        setLoading,
        goReport,
        clearTimer,
        getProgress,
        startTimer,
        getProgressInFirst,
        reGenerateReport
    };
};

export default useEventResult;
